const ONBOARDING_PREVIEW_PARAM = 'onboarding-preview';

interface OnboardingPreviewInput {
  isDev: boolean;
  search: string;
}

export const isOnboardingPreviewEnabled = ({
  isDev,
  search,
}: OnboardingPreviewInput): boolean =>
  isDev &&
  new URLSearchParams(search).get(ONBOARDING_PREVIEW_PARAM) === '1';

export const removeOnboardingPreviewParam = (search: string): string => {
  const params = new URLSearchParams(search);
  params.delete(ONBOARDING_PREVIEW_PARAM);
  const nextSearch = params.toString();
  return nextSearch ? `?${nextSearch}` : '';
};
